import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useCreateCollectionLabelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { text: string }) => {
      return await collectionApiClient.createLabel(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["collection-labels"] });
    },
    onError: (error) => {
      console.error("Failed to create label:", error);
    },
  });
};

export default useCreateCollectionLabelMutation;
